import { useEffect, useState } from "react";

export default function ({ action, cancel }) {
    const [reported, setReported] = useState(false);

    useEffect(() => {
        if (reported) {
            setTimeout(() => {
                action();
                cancel();
            }, 1000);
        }
    }, [reported]);

    return (
        <>
            <h3 className="text-lg leading-6 font-medium text-black">
                Prijavi neaktivan oglas!
            </h3>
            <div className="mt-2 px-7 py-3">
                <p className="text-sm text-gray-dark">
                    Ukoliko imaš informaciju da je oglas istekao, klikni na
                    dugme prijavi i naša ekipa će obaviti provjeru i ukloniti
                    oglas. Hvala!
                </p>
            </div>
            <div className="items-center px-4 py-3">
                <button
                    onClick={() => cancel()}
                    className="px-4 py-2 border-gray border text-base rounded-md w-32 inline-block mb-3 shadow-sm focus:outline-none focus:ring-2 hover:bg-gray-light mr-4"
                >
                    Odustani
                </button>
                <button
                    onClick={() => setReported(true)}
                    className="px-4 py-2 bg-green-500 text-white text-base rounded-md w-32 inline-block mb-3 shadow-sm hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-300"
                >
                    {reported ? "Hvala!" : "Prijavi"}
                </button>
            </div>
        </>
    );
}
